import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { useUploadWizard } from '../../../contexts/UploadWizardContext';
import { BatchDropZone } from '../DropZone';
import { FileWithStatus } from '../../../types';
import { SUPPORTED_UPLOAD_EXTENSIONS } from '../../../services/upload';

const FileSelectionStep2: React.FC = () => {
  const { state, setFiles } = useUploadWizard();

  const handleFilesChange = (newFiles: FileWithStatus[]) => {
    setFiles(newFiles);
  };

  const handleFileClick = (file: FileWithStatus) => {
    // In wizard mode, we don't handle file clicks in the first step
    // File editing will happen in later steps
    console.log('File clicked:', file.name);
  };

  const handleFileDelete = (fileId: string) => {
    const updatedFiles = state.files.filter(f => f.id !== fileId);
    setFiles(updatedFiles);
  };

  return (
    <Box sx={{ p: 4 }}>
    
      {/* File Drop Zone */}
      <BatchDropZone
        files={state.files}
        onFilesChange={handleFilesChange}
        onFileClick={handleFileClick}
        onFileDelete={handleFileDelete}
        accept={Array.from(SUPPORTED_UPLOAD_EXTENSIONS)}
        maxSize={2 * 1024 * 1024 * 1024} // 2GB
      />

      {/* Selection Summary */}
      {state.files.length > 0 && (
        <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="subtitle2" gutterBottom>
            Selection Summary
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {state.files.length} file(s) selected
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Total size: {Math.round(
              state.files.reduce((sum, file) => sum + file.size, 0) / 1024 / 1024 * 100
            ) / 100} MB
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default FileSelectionStep2;